import { render, staticRenderFns } from "./EditarImplemento.vue?vue&type=template&id=81007020"
import script from "./EditarImplemento.vue?vue&type=script&lang=js"
export * from "./EditarImplemento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports